export const STEP_STATUS = {
  ACTIVE: 'active',
  PROCESSED: 'processed',
  INACTIVE: 'inactive',
};

export const CONNECTION_OPTIONS = {
  NEW: 'new',
  EXISTING: 'existing',
  EXISTING_ELFOA2P: 'existing_elfoa2p',
  EXISTING_BSP: 'existing_bsp',
};

export const PHONE_VALIDATION_OPTIONS = {
  NEW: 'new',
  EXISTING: 'existing',
  NONE: 'none',
};

export const TOOLTIPS = {
  NEW_CONNECTION:
    'Select this option if you want to create a new WhatsApp Business Platform (API) account and connect with a new phone number.',
  EXISTING_BSP:
    'Select this option if your account was created on other platforms, and it is currently tied to another WhatsApp Business Provider (BSP) such as Messagebird or Vonage etc. Choosing this option will allow you to migrate your existing account to elfoA2P',
};

export const DESCRIPTIONS = {
  CONNECT_FACEBOOK:
    'Once you click "Connect with Facebook," you will be redirected to Facebook to choose the account you wish to connect. Follow the instructions to create, set up, and configure the new WhatsApp Business Platform (API). Afterward, you will be redirected back to this page.',
  ELIGIBILITY_CHECK: "Let's Begin with A Quick Eligibility Check",
  MIGRATION_REQUIREMENTS:
    'Before proceeding with the migration, make sure you fully understand the requirements.',
};
